import {sortByKey} from 'presentation/utils';
import {GetLocalitiesProps} from './types';
import {getLocalitiesFactory} from './utils/getLocalitiesFactory';

async function getLocalities({flowType, stateCode, signal}: GetLocalitiesProps) {
	const factory = getLocalitiesFactory(flowType);
	const localities = await factory.get({stateCode, signal});

	const localitiesSorted = sortByKey(localities.localidades, 'nmLocal');

	return localitiesSorted;
}

export {getLocalities};
